import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import LazyLoadImage from '../components/LazyLoadImage';

const ProductDetail = () => {

    const { id } = useParams();
    const { addToCart } = useCart();
    const navigate = useNavigate();

    const [notification, setNotification] = useState({ show: false, message: '' });
    const [getProd, setGetProd] = useState(null);
    const [quantity, setQuantity] = useState(1);
    const [loading, setLoading] = useState(true);

    const handleAddToCart = () => {
        if (!getProd) return;

        const productWithQty = {
            id: getProd.product_id,
            name: getProd.product_name,
            price: Number(getProd.product_price),
            image: getProd.pi_images?.[0]
                ? `https://roughradio.demo-customproject.com/backend/${getProd.pi_images[0].pi_image_path}${getProd.pi_images[0].pi_image}`
                : "",
            quantity: quantity
        };

        addToCart(productWithQty);

        setNotification({
            show: true,
            message: `${getProd.product_name} added to cart!`
        });

        setTimeout(() => {
            setNotification({ show: false, message: '' });
            navigate('/cart');
        }, 3000);
    };


    const handleViewCart = () => {
        navigate('/cart');
    };

    const getProdData = async () => {
        try {
            setLoading(true);
            const res = await axios.get(
                `https://roughradio.demo-customproject.com/backend/api/product-detail/${id}`
            );
            const productDetail = res.data.data;
            setGetProd(productDetail);
        } catch (err) {
            console.error("Fetching Product Detail Error:", err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getProdData();
    }, [id]);

    if (loading) return <div style={{ textAlign: "center" }}>
        <LazyLoadImage />
    </div>;

    return (
        <section className='product_detail_secc'>
            {notification.show && (
                <div className="cart-notification">
                    <i className="fas fa-check-circle"></i>
                    <span>{notification.message}</span>
                    <button onClick={handleViewCart} className="view-cart-btn">
                        View Cart
                    </button>
                </div>
            )}

            <div className='container'>
                <div className='row'>
                    <div className='col-lg-6'>
                        <div className='product_det_imggs'>
                            <img
                                src={
                                    getProd?.pi_images?.length > 0
                                        ? `https://roughradio.demo-customproject.com/backend/${getProd.pi_images[0].pi_image_path}${getProd.pi_images[0].pi_image}`
                                        : "images/loader.gif"
                                }
                                alt={getProd?.product_name}
                            />

                        </div>
                    </div>

                    <div className='col-lg-6'>
                        <div className='product_det_textt'>
                            <h2>{getProd?.product_name}</h2>
                            <p>{getProd?.product_desc}</p>
                            <span>£{getProd?.product_price}</span>
                            <button
                                onClick={handleAddToCart}
                                className="shop-btn">
                                Add To Cart <i class="fas fa-shopping-cart" aria-hidden="true"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ProductDetail;
